module.exports = __webpack_public_path__ + "static/media/IMG_4024.35ef95d3.jpg";